import { useEffect } from "react";

import useAppStore from "@/store/app-store";
import usePricingStore from "@/store/pricing-store";

const PROMO_CODE_PARAM = "promo_code";

const useApplyPromoCodeFromParam = () => {
  const { setPricingPromoCode } = usePricingStore();
  const { setApplyPromoCodeFromParmOnBuyPlan } = useAppStore();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const promoCode = params.get(PROMO_CODE_PARAM);

    if (promoCode) {
      setPricingPromoCode(promoCode);
      setApplyPromoCodeFromParmOnBuyPlan(true);
    }
  }, [setPricingPromoCode]);
};

export default useApplyPromoCodeFromParam;
